import React from 'react';
import styled from 'styled-components';

import { ContainerWithLogo } from '@app/components';
import CurrentSubscriptions from './components/CurrentSubscriptions';

const Subscription = () => (
  <ContainerWithLogo titleLabel="subscription.title">
    <SubscriptionContainer>
      <CurrentSubscriptions />
    </SubscriptionContainer>
  </ContainerWithLogo>
);

export default Subscription;

const SubscriptionContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;  
  height: 100%;
  max-width: 820px;
  padding: 10px;
`;
